export default "__VITE_ASSET__527c9afe__"